import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex-grow px-4 py-2 md:px-12 md:py-4 w-full" }
const _hoisted_2 = {
  id: "main-content",
  class: "text-muted text-lg"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "i-svg-spinners:90-ring-with-bg h-4 w-4 mr-2",
  "aria-hidden": "true"
}
const _hoisted_7 = {
  "aria-live": "polite",
  "aria-atomic": "true",
  class: "sr-only"
}
const _hoisted_8 = {
  key: 0,
  role: "alert",
  class: "text-red-600 dark:text-red-400 text-sm"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'feedback',
  setup(__props) {

const feedback = ref('')
const status = ref<'idle' | 'pending' | 'error'>('idle')

const statusMessage = computed(() => {
  if (status.value === 'pending') return 'Submitting feedback...'
  if (status.value === 'error') return 'Error submitting feedback. Please try again.'
  return ''
})

async function submitFeedback () {
  if (!feedback.value.trim()) return

  status.value = 'pending'
  try {
    await apiFetch('/api/feedback', {
      method: 'POST',
      body: { feedback: feedback.value },
    })
    await navigateTo('/voted')
  }
  catch {
    status.value = 'error'
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("form", {
        class: "flex flex-col items-start py-8 gap-2",
        onSubmit: _withModifiers(submitFeedback, ["prevent"])
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("label", {
          for: "feedback",
          class: "text-2xl leading-none mt-[5vw] mb-[1vw] max-w-[37.50rem]"
        }, " What do you think, in one word or one sentence? ", -1)),
        _withDirectives(_createElementVNode("textarea", {
          id: "feedback",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(feedback) ? (feedback).value = $event : null)),
          name: "feedback",
          rows: "3",
          autocomplete: "off",
          class: "rounded w-full max-w-400px bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 px-3 py-2 text-base f-ring-inset",
          disabled: _unref(status) === 'pending'
        }, null, 8, _hoisted_3), [
          [_vModelText, _unref(feedback)]
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "submit",
            class: "underlined-link outline-none focus-visible:after:opacity-35 py-2 disabled:opacity-50",
            disabled: _unref(status) === 'pending' || !_unref(feedback).trim()
          }, [
            (_unref(status) === 'pending')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6))
              : _createCommentVNode("", true),
            _cache[1] || (_cache[1] = _createTextVNode(" Submit ", -1))
          ], 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(statusMessage)), 1),
        (_unref(status) === 'error')
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Something went wrong. Please try again. "))
          : _createCommentVNode("", true)
      ], 32)
    ])
  ]))
}
}

})